// extracted by mini-css-extract-plugin
export default {"wrapper":"WaveForm_wrapper__E0v1+","input":"WaveForm_input__0NU0D","input__label":"WaveForm_input__label__hIRzf","actions":"WaveForm_actions__6YnCx"};